import Autosuggest from '@myap/ui-library/esm/components/forms/Autosuggest'

export const AutosuggestProxy = props => {
  const { input, meta, ...remainingProps } = props
  const mergedProps = { ...input, ...remainingProps }
  return <Autosuggest {...mergedProps} />
}
